export default function () {
  jQuery(document).ready((e) => {
    $('a.caption-panel').each(function () {
      const selector = $(this).attr('aria-controls');

      this.addEventListener('click', () => {
        togglePanel(selector);
      });
      this.addEventListener('keydown', () => {
        togglePanelKey(selector);
      });
    });

    function togglePanel(selector) {
      const panel = document.getElementById(selector);
      const bool = panel.getAttribute('aria-hidden') === 'true';

      panel.classList.toggle('opened');
      panel.setAttribute('aria-hidden', !bool);
    }

    function togglePanelKey(e) {
      if (e.keyCode === 13) {
        togglePanel();
      }
    }
  });
}



// WEBPACK FOOTER //
// ./themes/app/src/js/captions.js